import { NftEntity } from 'Entities'
import BaseService from 'Webservices/BaseService'

type IParamsGet = {} | null

type IQueryString = {
  userAddress: string
  tokenAddress?: string
}


export default class Balances extends BaseService {
  protected static readonly webServiceUrl = new URL(`${process.env.REACT_APP_API_BASEPATH}/erc721/balances`)

  public static async get(params: IParamsGet, queryString: IQueryString): Promise<NftEntity[]> {
    Object.entries(queryString).forEach(([key, value]) => Balances.webServiceUrl.searchParams.set(key, value))
    return (await this.httpGet(Balances.webServiceUrl)).json()
  }
}
